export enum MachineRequestType {
	Stillage = 0,
	Blanks = 10,
	Box = 20,
	Fixings = 30,
	Parts = 40
}